
export enum UserRole {
  Customer= 'Customer',
  SalesRep= 'SalesRep',
  Scrapyard= 'Scrapyard',
  CustomerService= 'CustomerService',

}